import {
	StyledContainer,
	StyledFirstCircle,
	StyledSecondCircle,
	StyledThirdCircle,
} from './HeadInfoMessageBG.styled';

const HeadInfoMessageBG: React.FC = () => {
	return (
		<StyledContainer>
			<StyledFirstCircle />
			<StyledSecondCircle />
			<StyledThirdCircle />
		</StyledContainer>
	);
};

export { HeadInfoMessageBG };
